import { EventSchema } from '../../interfaces/EventInterfaces'
import { EVENT_NAME as EN } from '../../constants/EventName'
import { EVENT_PARAM_KEY as EPK } from '../../constants/EventParamKey'
import { CommonEventProperties } from '../../utils/CommonParams'

export const BannerClickedEventSchema: EventSchema = {
  eventName: EN.BANNER_CLICKED,
  params: {
    ...CommonEventProperties,
    BUSINESS_VERTICAL: EPK.BUSINESS_VERTICAL,
    EVENT_CATEGORY: EPK.EVENT_CATEGORY,
    CONTENT: EPK.CONTENT,
  },
}
